export const CHARS = {
  longDash: '—',
  middleDash: '–',
  nbsp: '\xa0',
  tab: '\t',
  tildeEqual: '≃',
  middleDot: '•',
  nonBreakingHyphen: '‑',
} as const;
